<div class="generalPage" aria-label="help-printing" role="main">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-1rem" role="heading">{{printing_heading}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="printing_desc"></p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="printing_para1body"></p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="printing_para3body"></p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="printing_para4body"></p>
  </div>
</div>
